module.exports = __webpack_public_path__ + "img/bps_loader.e65e333d.gif";